// Can probably delete this beacuse only one room per user is allowed
export type UserRoomLink = {
    id: string,
    roomId: string,
    userId: string,
};

export type User = {
    id: string,
    name: string,
};

export enum GameStatus {
    WaitingToStartGame,
    RoundInProgress,
    WaitingToStartNextDrawer,
    GameOver,
}

export enum Tools {
    Pencil,
    Eraser,
}

export type Room = {
    id: string,

    // The status of the game;
    gameStatus: GameStatus,

    // Go around 2 or 3 times
    round: number,

    // The person drawing
    drawer?: string,

    // When the current round ends
    roundEndTime?: number,

    // The answer for the current round
    answer?: string,

    // Players who need to draw
    usersLeftInRound?: { [userId: string]: boolean },

    // Players who have guessed right
    correctUsers?: { [userId: string]: Date | boolean },

    // The user id who will
    // trigger end of round etc
    primaryUserId?: string,

    scores?: { [userId: string]: number },
};

export type Message = {
    id: string,
    roomId: string,
    userId: string,
    content: string,
};

export type Stroke = {
    id: string,
    roomId: string,
    start: [number, number],
    end: [number, number],
    strokeStyle: string,
    lineWidth: number,
};

export type Users = {
    [id: string]: User,
};
